import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  Input,
  InputLabel,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = ({ nazivPolja, props }: { nazivPolja: string; props?: any }) => {
  const { register, getValues, watch } = useFormContext();
  const value = watch(nazivPolja);
  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardHeader
        title={"Primarna kontakt adresa (Primary contact address)"}
        titleTypographyProps={{ variant: "h6" }}
      ></CardHeader>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth error={!daLiJePoljeValidno(nazivPolja)}>
              <InputLabel htmlFor={nazivPolja}>
                *Email adresa (Email address)
              </InputLabel>
              <Input
                disabled={true}
                value={value || ""}
                aria-describedby="email adresa"
                {...register(nazivPolja)}
                {...props}
              />
              <PorukaGreskePolja nazivPolja={nazivPolja} />
            </FormControl>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Index;
